// A powered device reaches the internet. The Wi-Fi network built into its image comes up first and
// an Ethernet cable is plugged in ten seconds later; a drawing with no Wi-Fi goes straight to the
// cable. Its light flickers as it activates.
const LEAD = 0.6, WAIT = 10, HOLD = 50

const clamp = (x, a = 0, b = 1) => Math.min(b, Math.max(a, x))
const ease = t => t * t * (3 - 2 * t)

function build(el) {
  const part = name => el.querySelector(`.${name}`)
  const plug = el.classList.contains('is-ethernet') ? 0.3 : WAIT

  return {
    plug, end: plug + 1.2 + HOLD, scene: part('scene'), ethernet: part('ethernet'), link: part('link'), led: part('led'),
    wifi: part('wifi'), dot: part('dot'), arcs: [...el.querySelectorAll('.wifi .arc')]
  }
}

function draw({plug, end, scene, ethernet, link, led, wifi, dot, arcs}, t) {
  const cabled = ease(clamp((t - plug) / 0.8)), wired = clamp((t - plug - 0.9) / 0.3), online = clamp((t - 1.5) / 0.4)

  scene.setAttribute('opacity', (1 - clamp((t - end) / 0.6)).toFixed(3))
  led.style.fill = Math.floor(t / 0.1) % 2 == 0 ? '#7dff9b' : '#3c8f57'

  ethernet.setAttribute('transform', `translate(${(52 * (1 - cabled)).toFixed(2)} 0)`)
  ethernet.setAttribute('opacity', clamp((t - plug + 0.1) / 0.2).toFixed(3))
  link.setAttribute('opacity', wired.toFixed(3))

  wifi.style.stroke = `color-mix(in srgb, #4a90e2 ${Math.round(online * 100)}%, #c5ccd6)`
  dot.style.fill = wifi.style.stroke
  dot.setAttribute('opacity', clamp((t - 0.3) / 0.2).toFixed(3))
  arcs.forEach((arc, i) => arc.setAttribute('opacity', clamp((t - 0.4 - 0.35 * i) / 0.3).toFixed(3)))
}

let Hooks = {}

Hooks['Animations.DeviceConnect'] = {
  mounted() {
    const scene = build(this.el)

    // Connected, held still.
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return draw(scene, scene.plug + 2)

    const start = performance.now()
    const frame = now => {
      draw(scene, ((now - start) / 1000) % (LEAD + scene.end + 1.1) - LEAD)
      this.raf = requestAnimationFrame(frame)
    }
    this.raf = requestAnimationFrame(frame)
  },

  destroyed() {
    cancelAnimationFrame(this.raf)
  }
}

export {Hooks}
